<template>
    <svg
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="$attrs.class + ' object-contain overflow-hidden'"
    >
        <path
            d="M60.0004 117.6C91.812 117.6 117.6 91.8115 117.6 59.9999C117.6 28.1883 91.812 2.3999 60.0004 2.3999C28.1888 2.3999 2.40039 28.1883 2.40039 59.9999C2.40039 91.8115 28.1888 117.6 60.0004 117.6Z"
            fill="#0E0A0A"
            stroke="#434343"
            stroke-width="2"
        />
        <path
            d="M60.0002 60L51.749 7.79275C57.2158 6.92781 62.7846 6.92781 68.2514 7.79275L60.0002 60Z"
            fill="#2E2525"
            stroke="#141414"
        />
        <path
            d="M60 60.0002L68.2512 7.79297C73.8392 8.69242 79.2462 10.4845 84.2652 13.1006L60 60.0002Z"
            fill="#3C3232"
            stroke="#141414"
        />
        <path
            d="M60 60.0002L84.2652 13.1006C89.0879 15.5974 93.4966 18.8234 97.3356 22.6646L60 60.0002Z"
            fill="#2E2525"
            stroke="#141414"
        />
        <path
            d="M60 60.0001L97.3356 22.6646C101.177 26.5036 104.403 30.9122 106.9 35.735L60 60.0001Z"
            fill="#3C3232"
            stroke="#141414"
        />
        <path
            d="M60 60.0001L106.9 35.7349C109.516 40.7539 111.308 46.1609 112.207 51.7489L60 60.0001Z"
            fill="#2E2525"
            stroke="#141414"
        />
        <path
            d="M60 59.9997L112.207 51.7485C113.072 57.2153 113.072 62.7841 112.207 68.2509L60 59.9997Z"
            fill="#3C3232"
            stroke="#141414"
        />
        <path
            d="M60 60L112.207 68.2512C111.308 73.8392 109.516 79.2462 106.9 84.2652L60 60Z"
            fill="#2E2525"
            stroke="#141414"
        />
        <path
            d="M60 60L106.9 84.2652C104.403 89.0879 101.177 93.4966 97.3356 97.3356L60 60Z"
            fill="#3C3232"
            stroke="#141414"
        />
        <path
            d="M60 60L97.3356 97.3356C93.4966 101.177 89.0879 104.403 84.2652 106.9L60 60Z"
            fill="#2E2525"
            stroke="#141414"
        />
        <path
            d="M60 60L84.2652 106.9C79.2462 109.516 73.8392 111.308 68.2512 112.207L60 60Z"
            fill="#3C3232"
            stroke="#141414"
        />
        <path
            d="M60.0002 60L68.2514 112.207C62.7846 113.072 57.2158 113.072 51.749 112.207L60.0002 60Z"
            fill="#2E2525"
            stroke="#141414"
        />
        <path
            d="M60.0006 60L51.7494 112.207C46.1614 111.308 40.7544 109.516 35.7354 106.9L60.0006 60Z"
            fill="#3C3232"
            stroke="#141414"
        />
        <path
            d="M60.0006 60L35.7354 106.9C30.9127 104.403 26.5041 101.177 22.665 97.3356L60.0006 60Z"
            fill="#2E2525"
            stroke="#141414"
        />
        <path
            d="M60.0002 60L22.6646 97.3356C18.8234 93.4966 15.5974 89.0879 13.1006 84.2652L60.0002 60Z"
            fill="#3C3232"
            stroke="#141414"
        />
        <path
            d="M60.0002 60L13.1006 84.2652C10.4845 79.2462 8.69242 73.8392 7.79297 68.2512L60.0002 60Z"
            fill="#2E2525"
            stroke="#141414"
        />
        <path
            d="M60.0004 59.9997L7.79324 68.2509C6.9283 62.7841 6.9283 57.2153 7.79324 51.7485L60.0004 59.9997Z"
            fill="#3C3232"
            stroke="#141414"
        />
        <path
            d="M60.0002 60.0001L7.79297 51.7489C8.69242 46.1609 10.4845 40.7539 13.1006 35.7349L60.0002 60.0001Z"
            fill="#2E2525"
            stroke="#141414"
        />
        <path
            d="M60.0002 60.0001L13.1006 35.735C15.5974 30.9122 18.8234 26.5036 22.6646 22.6646L60.0002 60.0001Z"
            fill="#3C3232"
            stroke="#141414"
        />
        <path
            d="M60.0006 60.0002L22.665 22.6646C26.5041 18.8234 30.9127 15.5974 35.7354 13.1006L60.0006 60.0002Z"
            fill="#2E2525"
            stroke="#141414"
        />
        <path
            d="M60.0006 60.0002L35.7354 13.1006C40.7544 10.4845 46.1614 8.69242 51.7494 7.79297L60.0006 60.0002Z"
            fill="#3C3232"
            stroke="#141414"
        />

        <!-- Segment highlights, brightest (current) to dimmest (third). Each wedge's
        single/triple/double bands are defined at the top (the "20" position) and the
        group is rotated about the board centre to land on its number. -->
        <g
            v-for="highlight in wedgeHighlights"
            :key="highlight.key"
            :transform="`rotate(${highlight.rotation} 60 60)`"
        >
            <!-- Points mode highlights the entire number (any part scores), so all
            three bands light up. Race mode only highlights the targeted band. -->
            <path
                v-if="showFullSegment || highlight.segment.type === DART_TYPES.SINGLE"
                :d="bands.single"
                :class="highlight.colorClass + ' stroke-bg stroke-0.25'"
            />
            <path
                v-if="showFullSegment || highlight.segment.type === DART_TYPES.TRIPLE"
                :d="bands.triple"
                :class="highlight.colorClass + ' stroke-bg stroke-0.25'"
            />
            <path
                v-if="showFullSegment || highlight.segment.type === DART_TYPES.DOUBLE"
                :d="bands.double"
                :class="highlight.colorClass + ' stroke-bg stroke-0.25'"
            />
        </g>

        <path
            d="M60 72C66.6274 72 72 66.6274 72 60C72 53.3726 66.6274 48 60 48C53.3726 48 48 53.3726 48 60C48 66.6274 53.3726 72 60 72Z"
            :class="bullFillClass(DART_TYPES.OUTER_BULL, 'fill-[#1A1010]')"
            stroke="#141414"
        />
        <path
            d="M59.9996 65.4001C62.9819 65.4001 65.3996 62.9824 65.3996 60.0001C65.3996 57.0178 62.9819 54.6001 59.9996 54.6001C57.0173 54.6001 54.5996 57.0178 54.5996 60.0001C54.5996 62.9824 57.0173 65.4001 59.9996 65.4001Z"
            :class="bullFillClass(DART_TYPES.BULL, 'fill-[#303030]')"
        />
    </svg>
</template>

<script>
import { DART_TYPES } from '@/constants/dartTypes.js'

const CENTER = 60
// Ring radii read off the board artwork so the highlight bands line up with it.
const RADIUS = { outerBull: 12, tripleIn: 31.4, tripleOut: 35.5, doubleIn: 48.66, doubleOut: 52.86 }
// Numbers clockwise from the top (20 at 12 o'clock), 18° per wedge.
const NUMBER_ORDER = [20, 1, 18, 4, 13, 6, 10, 15, 2, 17, 3, 19, 7, 16, 8, 11, 14, 9, 12, 5]
// Highlight fill classes from current target (brightest) to third (dimmest).
const HIGHLIGHT_CLASSES = ['fill-red-600', 'fill-red-800', 'fill-red-900']

// Angle measured clockwise from the top of the board.
function pointAt(radius, deg) {
    const rad = (deg * Math.PI) / 180
    return [CENTER + radius * Math.sin(rad), CENTER - radius * Math.cos(rad)]
}

// Annular sector between two radii, spanning the top wedge (-9° to +9°).
function sectorPath(rIn, rOut) {
    const f = (n) => n.toFixed(3)
    const [x1, y1] = pointAt(rIn, -9)
    const [x2, y2] = pointAt(rOut, -9)
    const [x3, y3] = pointAt(rOut, 9)
    const [x4, y4] = pointAt(rIn, 9)
    return (
        `M${f(x1)} ${f(y1)} L${f(x2)} ${f(y2)} ` +
        `A${rOut} ${rOut} 0 0 1 ${f(x3)} ${f(y3)} L${f(x4)} ${f(y4)} ` +
        `A${rIn} ${rIn} 0 0 0 ${f(x1)} ${f(y1)} Z`
    )
}

export default {
    name: 'SegmentsDartboard',
    props: {
        // The current target to highlight (brightest): { type, number }.
        activeSegment: {
            type: Object,
            default: null,
        },
        // Optional next target, shown a shade darker.
        nextSegment: {
            type: Object,
            default: null,
        },
        // Optional target after that, shown darker still.
        thirdSegment: {
            type: Object,
            default: null,
        },
        // Points mode: highlight the whole number wedge (and both bull rings for a
        // bull target) since any part of it scores, rather than a single band.
        showFullSegment: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            DART_TYPES,
            bands: {
                // A single covers the inner and outer single bands either side of the triple.
                single: `${sectorPath(RADIUS.outerBull, RADIUS.tripleIn)} ${sectorPath(RADIUS.tripleOut, RADIUS.doubleIn)}`,
                triple: sectorPath(RADIUS.tripleIn, RADIUS.tripleOut),
                double: sectorPath(RADIUS.doubleIn, RADIUS.doubleOut),
            },
        }
    },
    computed: {
        // The target segments paired with their highlight fill class, brightest first.
        highlights() {
            return [this.activeSegment, this.nextSegment, this.thirdSegment]
                .map((segment, index) => ({ segment, colorClass: HIGHLIGHT_CLASSES[index], key: index }))
                .filter((highlight) => highlight.segment)
        },
        // Highlights that land on a numbered wedge (i.e. not the bulls), with the
        // board rotation that brings the top wedge onto their number.
        wedgeHighlights() {
            return this.highlights
                .map((highlight) => ({ ...highlight, rotation: this.rotationFor(highlight.segment) }))
                .filter((highlight) => highlight.rotation !== null)
        },
    },
    methods: {
        // Rotation (deg) onto a segment's number, or null for bulls / unknown numbers.
        rotationFor(segment) {
            if (segment.type === DART_TYPES.BULL || segment.type === DART_TYPES.OUTER_BULL) {
                return null
            }
            const index = NUMBER_ORDER.indexOf(segment.number)
            return index === -1 ? null : index * 18
        },
        // Fill class for a bull ring: the first highlight (active before next/third)
        // that covers the ring, else the default.
        bullFillClass(type, defaultClass) {
            const highlight = this.highlights.find((h) => this.coversBullRing(h.segment, type))
            return highlight ? highlight.colorClass : defaultClass
        },
        // Mirrors what scores in full-segment (points) mode: a single bull target
        // also accepts the bullseye, so it covers both rings, while a bullseye
        // target only covers the inner ring.
        coversBullRing(segment, ring) {
            if (segment.type === ring) return true
            return (
                this.showFullSegment &&
                segment.type === DART_TYPES.OUTER_BULL &&
                ring === DART_TYPES.BULL
            )
        },
    },
}
</script>
